module.exports = __webpack_public_path__ + "img/caret-up.902d3aa3.svg";